// extracted by mini-css-extract-plugin
export default {"navbarlebelsec":"navbarlabel_navbarlebelsec__9gD1B","navbarlabel":"navbarlabel_navbarlabel__xK944"};